import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Spinner } from 'react-bootstrap';
import { fetchConToken } from '../../api/fetch';
import { useContextInfo } from '../../context/ContextInfo';
import { useForm } from '../../hooks/useForm';
import { useGetDta } from '../../hooks/useGetDta';

const ConfigIps = () => {
    const { setResp } = useContextInfo();
    const { loading, data } = useGetDta('main/general/ips-nat');

    const [load, setLoad] = useState(false);
    const [validated, setValidated] = useState(false);
    const [values, handleInputChange, setFormValue] = useForm({
        id: '',
        ip_aviso: '',
        ip_moroso: '',
    });
    useEffect(() => {
        if (data.id) {
            const datos = JSON.parse(data.items);

            setFormValue({ ...values, ...datos, id: data.id });
        }
    }, [data]);

    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(`proxy/ipsnat`, { id: values.id, items: { ...values } }, 'PUT');
            setResp(res);
        }
        setLoad(false);
    };
    return (
        <Card>
            <Card.Header>
                <h4>Ips para avisos</h4>
                <small>
                    <b>Ips que se agregan a las reglas del nat</b>
                </small>
            </Card.Header>
            <Card.Body>
                <Form noValidate validated={validated} onSubmit={onSubmit}>
                    <Col>
                        {' '}
                        <Form.Group className="mb-2" controlId="validationCusto">
                            <Form.Label>Ip permitidas para aviso</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                value={values.ip_aviso}
                                name="ip_aviso"
                                onChange={handleInputChange}
                            />
                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                        </Form.Group>{' '}
                    </Col>
                    <Col>
                        {' '}
                        <Form.Group className="mb-2" controlId="validationCusto">
                            <Form.Label>Ip permitida para mororsos</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                value={values.ip_moroso}
                                name="ip_moroso"
                                onChange={handleInputChange}
                            />
                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                        </Form.Group>{' '}
                    </Col>
                    {load ? (
                        <Button color="primary" disabled>
                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                            Guardando...
                        </Button>
                    ) : (
                        <Button type="submit">Guardar</Button>
                    )}
                </Form>{' '}
            </Card.Body>
        </Card>
    );
};

export default ConfigIps;
